export const BETFINDER = 'betfinder';
export const BETFINDER_SELECTION_BLOCK = `${BETFINDER}_selection`;
export const BETFINDER_RESULT_BLOCK = `${BETFINDER}-result-element`;
export const HORSE_RACING_BUTTON = 'bet_buttons';
export const WITHDRAWN_LABEL = 'withdrawn';
export const HORSE_RACING_EVENT_MODULE_NAME = 'horse-racing';
export const HORSE_RACING_CSS_BLOCK_YELLOWSTONE = 'HorseRacingYellowstoneRacecard';
export const HORSE_RACING_INIT_EVENT_NAME = `${HORSE_RACING_EVENT_MODULE_NAME}:init-selections`;
export const HORSE_RACING_UPDATE_EVENT_NAME = `${HORSE_RACING_EVENT_MODULE_NAME}:update-selections`;
export const HORSE_RACING_SELECTOR_TAG = 'div';
export const HORSE_RACING_SELECTOR_ATTR = 'data-selection-id';
export const HORSE_RACING_CAST_MARKET = 'cast-market';
export const HORSE_RACING_CAST_PRICE = `${HORSE_RACING_CSS_BLOCK_YELLOWSTONE}__selection__price`;
export const HORSE_RACING_CAST_WITHDRAWN_LABEL ='Withdrawn';
export const RACING_UK ='RACING_UK';
export const AT_THE_RACES = 'AT_THE_RACES';
export const SIS = 'SIS';
export const TROTTING_BUTTON = 'bet_buttons';
export const TROTTING_EVENT_MODULE_NAME = 'trotting';
export const TROTTING_INIT_EVENT_NAME = `${TROTTING_EVENT_MODULE_NAME}:init-selections`;
export const TROTTING_UPDATE_EVENT_NAME = `${TROTTING_EVENT_MODULE_NAME}:update-selections`;
export const GTM_CLICK_EVENT = 'event-page';
